"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.upload.mode.title': 'Choose Data Input Method',
    'trainer.upload.mode.file': 'Upload CSV File',
    'trainer.upload.mode.manual': 'Manual Entry',
    'trainer.upload.mode.pdf': 'PDF Processing',
    'trainer.upload.mode.file.description': 'Upload a pre-formatted CSV file with your training data',
    'trainer.upload.mode.manual.description': 'Create training data using a user-friendly form interface',
    'trainer.upload.mode.pdf.description': 'Upload a PDF to automatically extract and generate training data from chapters',
    'trainer.upload.title': 'Upload Training Data (CSV)',
    'trainer.upload.format.required': 'Required CSV Format:',
    'trainer.upload.format.input': 'The prompt/question text',
    'trainer.upload.format.output': 'The expected response/answer',
    'trainer.upload.format.category': 'Classification category',
    'trainer.upload.format.optional': 'optional',
    'trainer.upload.format.metadata': 'Additional metadata columns are supported and will be preserved.',
    'trainer.upload.processing': 'Processing file...',
    'trainer.upload.select': 'Select CSV File',
    'trainer.upload.file.info': 'File Information',
    'trainer.upload.file.name': 'Filename:',
    'trainer.upload.file.size': 'Size:',
    'trainer.upload.file.type': 'Type:',
    'trainer.upload.data.analysis': 'Data Analysis',
    'trainer.upload.stats.samples': 'Training Samples',
    'trainer.upload.stats.input.length': 'Avg Input Length',
    'trainer.upload.stats.output.length': 'Avg Output Length',
    'trainer.upload.stats.categories': 'Categories',
    'trainer.upload.stats.quality': 'Quality Score',
    'trainer.upload.categories.found': 'Categories found:',
    'trainer.upload.preview': 'Data Preview (First 3 rows)',
    'trainer.upload.preview.input': 'Input',
    'trainer.upload.preview.output': 'Output',
    'trainer.upload.preview.category': 'Category',
    'trainer.upload.manual.title': 'Create Training Data Manually',
    'trainer.upload.manual.description': 'Add training examples one by one using the form below. Each example should contain an input prompt and the expected output response.',
    'trainer.upload.manual.input': 'Input (Prompt)',
    'trainer.upload.manual.input.placeholder': 'Enter the prompt or question...',
    'trainer.upload.manual.output': 'Output (Response)',
    'trainer.upload.manual.output.placeholder': 'Enter the expected response...',
    'trainer.upload.manual.category': 'Category (Optional)',
    'trainer.upload.manual.category.placeholder': 'Enter a category label...',
    'trainer.upload.manual.add': 'Add Entry',
    'trainer.upload.manual.update': 'Update Entry',
    'trainer.upload.manual.cancel': 'Cancel Edit',
    'trainer.upload.manual.edit': 'Edit',
    'trainer.upload.manual.delete': 'Delete',
    'trainer.upload.manual.list.title': 'Training Data Entries',
    'trainer.upload.manual.export': 'Export as CSV',
    'trainer.upload.manual.validation.required': 'Both input and output fields are required',
    'trainer.upload.manual.export.empty': 'No training data to export',
    'trainer.upload.pdf.title': 'PDF Training Data Generation',
    'trainer.upload.pdf.description': 'Upload a PDF document to automatically extract text and generate training data organized by chapters.',
    'trainer.upload.pdf.upload.title': 'Upload PDF Document',
    'trainer.upload.pdf.select': 'Select PDF File',
    'trainer.upload.pdf.processing': 'Processing PDF...',
    'trainer.upload.pdf.extracting': 'Extracting chapters...',
    'trainer.upload.pdf.context.label': 'Context (Optional)',
    'trainer.upload.pdf.context.placeholder': 'Provide additional context about the document content to improve training data quality...',
    'trainer.upload.pdf.extract.button': 'Extract Chapters',
    'trainer.upload.pdf.chapters.title': 'Extracted Chapters',
    'trainer.upload.pdf.chapters.select': 'Select chapters to process:',
    'trainer.upload.pdf.chapters.selectall': 'Select All',
    'trainer.upload.pdf.chapters.deselectall': 'Deselect All',
    'trainer.upload.pdf.chapters.generate.button': 'Generate Training Data from Selected Chapters',
    'trainer.upload.pdf.chapters.generating': 'Generating training data...',
    'trainer.upload.pdf.chapters.preview': 'Preview:',
    'trainer.upload.pdf.chapters.words': 'words',
    'trainer.upload.pdf.file.info': 'PDF Information',
    'trainer.upload.pdf.file.name': 'Filename:',
    'trainer.upload.pdf.file.size': 'Size:',
    'trainer.upload.pdf.file.pages': 'Pages:',
    'trainer.upload.pdf.success': 'Training data generated successfully!',
    'trainer.upload.pdf.error': 'Error processing PDF. Please try again.',
    'trainer.upload.pdf.error.extraction': 'Failed to extract chapters from PDF',
    'trainer.upload.pdf.error.generation': 'Failed to generate training data',
    'trainer.upload.pdf.error.nofile': 'Please select a PDF file',
    'trainer.upload.pdf.error.nochapters': 'Please select at least one chapter',
};
